import LocationListView from './LocationListView'
import LocationListAdmin from './LocationListAdmin'

const useLocationList = () => {
    const viewSwitcher = (admin) => {
        if(admin){
            return <LocationListAdmin />
        }
        return <LocationListView />
    }

    return { viewSwitcher }
}

export default useLocationList